import React from 'react';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  title: 'TITLE',
  superhosts: 'SUPER HOSTS'
};

const additionalProps = {};

function HeaderStudyGroups({
  onChange,
  value: selectedValue,
}) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map(value => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value]) || {}}
        />
      ))}
    </tr>
  );
}

HeaderStudyGroups.defaultProps = {};

HeaderStudyGroups.propTypes = {};

export default HeaderStudyGroups;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/List/Headers.jsx